import { render } from "./3.Parallax.vue?vue&type=template&id=69ba85d4&scoped=true"
import script from "./3.Parallax.vue?vue&type=script&lang=js"
export * from "./3.Parallax.vue?vue&type=script&lang=js"

import "./3.Parallax.vue?vue&type=style&index=0&id=69ba85d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ba85d4"]])

export default __exports__